// extracted by css-extract-rspack-plugin
export default {"content":"content-33a_g","flexContainer":"flexContainer-2-ao0","linkBox":"linkBox-1HtLC","tab":"tab-3AVw4","label":"label-3j1J1"};